import { useState } from 'react'

import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import IconButton from '@mui/material/IconButton'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import DeleteIcon from '@mui/icons-material/Delete'
import ViewWeekIcon from '@mui/icons-material/ViewWeek'

import { useGridApiContext } from '@mui/x-data-grid-pro'
import { useGetViewsQuery, useDeleteViewMutation } from '../../../services/views/slice'

const LoadViewToolbar = () => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false)
  const [viewToDelete, setViewToDelete] = useState(null)

  const apiRef = useGridApiContext()
  const { data: views, isLoading: isViewsLoading } = useGetViewsQuery()
  const [deleteView] = useDeleteViewMutation()

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleDeleteClick = (view) => {
    setViewToDelete(view)
    setDeleteDialogOpen(true)
  }

  const confirmDelete = () => {
    deleteView(viewToDelete.id) // Replace with your delete logic if different
    setDeleteDialogOpen(false)
    setViewToDelete(null)
    handleClose()
  }

  const cancelDelete = () => {
    setDeleteDialogOpen(false)
    setViewToDelete(null)
    handleClose()
  }

  const loadGridState = (view) => {
    apiRef.current.restoreState(view)
    handleClose()
  }

  return (
    <>
      <Button
        size="small"
        startIcon={<ViewWeekIcon />}
        onClick={handleClick}
        disabled={isViewsLoading || views?.length === 0}
      >
        Load View ({views?.length || 0})
      </Button>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {views?.map((view) => (
          <MenuItem key={view.id} onClick={() => loadGridState(view.view)}>
            {view.name}
            <IconButton
              edge="end"
              aria-label="delete"
              onClick={(e) => {
                e.stopPropagation() // Prevents MenuItem click event
                handleDeleteClick(view)
              }}
            >
              <DeleteIcon />
            </IconButton>
          </MenuItem>
        ))}
      </Menu>

      <Dialog open={deleteDialogOpen} onClose={cancelDelete}>
        <DialogTitle id="alert-dialog-title">{'Delete View'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this view?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelDelete} color="primary">
            Cancel
          </Button>
          <Button onClick={confirmDelete} color="error">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default LoadViewToolbar
